import { FormattedMessage } from "react-intl";
import NationalTextField from "./NationalTextField";

export default function TrainerDataSection({ register, errors }) {
  return (
    <div className="data-form">
      <h5
        className="fw-bold mb-4 text-decoration-underline"
        style={{ color: "var(--main-color)" }}
      >
        <FormattedMessage id="trainnerData" />
      </h5>

      <NationalTextField
        register={register}
        name="trainerName"
        labelId="name"
        error={errors?.trainerName}
      />
      <NationalTextField
        register={register}
        name="trainerJobTitle"
        labelId="jobTitle"
        error={errors?.trainerJobTitle}
      />
      <NationalTextField
        register={register}
        name="trainerPhone"
        labelId="phoneNumber"
        type="tel"
        error={errors?.trainerPhone}
      />
      <NationalTextField
        register={register}
        name="trainerFax"
        labelId="fax"
        error={errors?.trainerFax}
      />
      <NationalTextField
        register={register}
        name="trainerEmail"
        labelId="email"
        type="email"
        error={errors?.trainerEmail}
      />
    </div>
  );
}
